import moment from "moment"
import { useState } from "react"
import { Modal, Form, Input, Button, message } from "antd"
import { CommentListing } from "./list"
import PropTypes from "prop-types"
import { loadingAlert, success } from "../../../../../helpers"
import { apolloError } from "../../../../../helpers/bugsnag/notify"
import { useAuth } from "../../../../../contexts/auth"

CommentModal.propTypes = {
  onCancel: PropTypes.func,
  onSave: PropTypes.func,
  onDelete: PropTypes.func,
  revision: PropTypes.string,
  readOnly: PropTypes.bool,
  refetch: PropTypes.func,
  comments: PropTypes.array,
  field: PropTypes.object
}

export function CommentModal ({
  onCancel,
  onSave,
  onDelete,
  revision,
  readOnly,
  refetch,
  comments,
  field,
  ...props
}) {
  const [reviewed, setReviewed] = useState([])
  const [form] = Form.useForm()

  const auth = useAuth() || {}
  const { user } = auth
  const userAuthenticate = user?.claims?.role

  const usersCanComment = ["ADMIN","ADMIN_TECHNICAL_AND_FINANCIAL"];

  const onOk = async () => {
    const values = await form.getFieldsValue()
    if (values.comment === undefined || values.comment.trim() === "") {
      return
    }

    const saving = loadingAlert()
    try {
      const newComment = {
        revision,
        type: field.section,
        fieldName: field.name,
        comment: values.comment,
        userRol: userAuthenticate,
        createdAt: moment().format(),
        [field.entity]: field.entityId
      }

    await onSave([newComment])
    form.resetFields()
    success("Guardado correctamente!")
    }
    catch (e) {
      apolloError(e)
    } finally {
      saving()
    }
  }

  const onDeleteComment = async ({ id }) => {
    const saving = loadingAlert()
    try {
      await onDelete({ variables: { data: [id] } })
      await refetch()
      success("Eliminado correctamente!")
    } catch (e) {
      apolloError(e)
    } finally {
      saving()
    }
  }

  const closeModal = async () => {
   const saving = message.loading("Guardando...")
      try {
        if (reviewed.length) {
        await onSave(reviewed)
        setReviewed([])
        await refetch()
        success("Comentarios revisados guardados")
        }
      } catch (e) {
        apolloError(e)
      } finally {
        saving()
        onCancel()
      }
  }
      <Modal
        id="comments-modal"
        title="Comentarios para revisión"
        onCancel={onCancel}
        footer={false}
        width={800}
        maskClosable={false}
        {...props}>
        <CommentListing comments={comments} readOnly={readOnly} />
      </Modal>

  return (
    <Modal
      id="comments-modal"
      title="Comentarios para revisión"
      onCancel={closeModal}
      cancelText="Cerrar"
      width={800}
      zIndex={1020}
      okButtonProps={{ hidden: true }}
      maskClosable={false}
      {...props}>
      {/* {!readOnly && ( */}
        <Form
          form={form}
          layout="vertical"
          style={{ display: "flex", flexDirection: "column" }}>
          <Form.Item name="comment" style={{ marginBottom: 10 }}>
            <Input.TextArea
              id="comment"
              placeholder="Describe los puntos a corregir" />
          </Form.Item>
          <Button
            disabled={!usersCanComment.includes(userAuthenticate)}
            type="primary"
            onClick={onOk}
            style={{ alignSelf: "flex-end" }}>
            Agregar
          </Button>
        </Form>
      <CommentListing
        comments={comments}
        onDelete={onDeleteComment}
        readOnly={readOnly}
        revision={revision}
        reviewed={reviewed}
        onSave={onSave}
        userAuthenticate={userAuthenticate}
        onReview={comment => setReviewed(reviewed => [...reviewed, comment])} />
    </Modal>
  )
}
